import { render } from "./DMonthWeekDay.vue?vue&type=template&id=12a28566&scoped=true"
import script from "./DMonthWeekDay.vue?vue&type=script&lang=js"
export * from "./DMonthWeekDay.vue?vue&type=script&lang=js"

import "./DMonthWeekDay.vue?vue&type=style&index=0&id=12a28566&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a28566"]])

export default __exports__